import { useProjectStore } from "@/stores/project-store";
import { useTasksStore } from "@/stores/tasks-store";
import type { WorkToastItem } from "@/stores/work-toast-store";
import { useWorkToastConversationTitle } from "./use-work-toast-conversation-title";

/** The project and task names a work toast's title and detail lines are built from. */
export function useWorkToastNames(item: WorkToastItem): {
  projectName: string | null;
  taskTitle: string | null;
  conversationTitle: string | null;
} {
  const conversationTitle = useWorkToastConversationTitle(
    item.source === "native_worker" ? null : item.conversationId,
  );
  const projectName = useProjectStore((state) =>
    item.projectId
      ? (state.projects.find((p) => p.id === item.projectId)?.name ?? null)
      : null,
  );
  const taskTitle = useTasksStore((state) =>
    item.taskId
      ? (state.tasks.find((task) => task.id === item.taskId)?.title ?? null)
      : null,
  );
  return { projectName, taskTitle, conversationTitle };
}
